module.exports = __webpack_public_path__ + "static/media/message-preferences-selected.87009392.svg";